import { TestimonialsColumn } from "./testimonials-columns-1";
import { motion } from "framer-motion";

// Function to create a deterministic "random" assignment based on name
const getAvatarForTestimonial = (name: string): string => {
  // Simple hash function to convert name to a number
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Get absolute value and map to avatar range (1-11)
  const avatarNumber = (Math.abs(hash) % 11) + 1;
  return `/img/avatars/avatar-${avatarNumber}.png`;
};

const testimonials = [
  {
    text: "Nosh has completely changed how I manage my kitchen. I've reduced my food waste by 70% and discovered amazing recipes I never would have tried!",
    image: getAvatarForTestimonial("Sarah J."),
    name: "Sarah J.",
    role: "Food Blogger",
  },
  {
    text: "The AI recipe suggestions are spot on! It's like having a personal chef who knows exactly what's in my fridge and what I like to eat.",
    image: getAvatarForTestimonial("Michael T."),
    name: "Michael T.",
    role: "Busy Parent",
  },
  {
    text: "I love the meal scanning feature for tracking calories. It's so much easier than manually logging everything, and surprisingly accurate!",
    image: getAvatarForTestimonial("Aisha K."),
    name: "Aisha K.",
    role: "Fitness Enthusiast",
  },
  {
    text: "The receipt scanning feature saves me so much time. I just snap a photo after grocery shopping and everything is added to my inventory automatically.",
    image: getAvatarForTestimonial("David L."),
    name: "David L.",
    role: "Tech Professional",
  },
  {
    text: "As a nutritionist, I recommend Nosh to all my clients. The detailed nutrition tracking and meal planning features are incredibly valuable.",
    image: getAvatarForTestimonial("Emma R."),
    name: "Emma R.",
    role: "Nutritionist",
  },
  {
    text: "The weekly meal planner has been a game-changer for my family. We waste less food, save money, and eat healthier meals.",
    image: getAvatarForTestimonial("James W."),
    name: "James W.",
    role: "Family Cook",
  },
  {
    text: "I've tried many food management apps, but Nosh is by far the most intuitive and comprehensive. The AI features are truly next level.",
    image: getAvatarForTestimonial("Sophia C."),
    name: "Sophia C.",
    role: "App Developer",
  },
  {
    text: "As someone with dietary restrictions, I appreciate how Nosh helps me find recipes that work with what I have and what I can eat.",
    image: getAvatarForTestimonial("Alex M."),
    name: "Alex M.",
    role: "Health Advocate",
  },
  {
    text: "The gamification elements make reducing food waste fun! I love earning points and seeing my environmental impact grow over time.",
    image: getAvatarForTestimonial("Olivia P."),
    name: "Olivia P.",
    role: "Environmental Scientist",
  },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 6);
const thirdColumn = testimonials.slice(6, 9);

const Testimonials = () => {
  return (
    <section className="bg-white my-20 relative">
      <div className="container z-10 mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          viewport={{ once: true }}
          className="flex flex-col items-center justify-center max-w-[540px] mx-auto"
        >
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold tracking-tighter mt-5">
            What Our Users Say
          </h2>
          <p className="text-center mt-5 opacity-75">
            See what our customers have to say about their experience with Nosh.
          </p>
        </motion.div>

        <div className="flex justify-center gap-6 mt-10 [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)] max-h-[740px] overflow-hidden">
          <TestimonialsColumn testimonials={firstColumn} duration={15} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={19} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={17} />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;